import React from 'react';
import { useFetchMonitoring } from '../model/useFetchMonitoring';
import ReactJson from 'react-json-view';

export default function TestToolPage() {
  const { value, handleChange, response, handleSubmit, error, isLoading, param } = useFetchMonitoring();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "120vh",
      }}
    >
      <div>
        <div>
          <span>Packet: </span>
        </div>
        <input type="text" value={value} onChange={handleChange} 
          style={{minWidth: "800px", height: "50px", fontSize: "20px"}}
        />
      </div>
      <button
        type="button"
        onClick={handleSubmit}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: "#007BFF",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        disabled={isLoading}
      >
        Send
      </button>
      <div>
        <div
          style={{
            marginBottom: "20px",
          }}
        >
          <span>Body</span>
        </div>
        <ReactJson name={false} displayDataTypes={false} displayObjectSize={false} src={param}  style={{ width: "800px", backgroundColor: "rgb(228, 228, 228)", padding: "10px", borderRadius: "10px"}}/>
      </div>
      <div>
        <div
          style={{
            marginBottom: "20px",
          }}
        >
          <span>Response</span>
        </div>
        <ReactJson name={false} displayDataTypes={false} displayObjectSize={false} src={error.isError ? error : response}  style={{ width: "800px", backgroundColor: "rgb(228, 228, 228)", padding: "10px", borderRadius: "10px"}}/>
        { (!response || response === "") && <span style={{ color: "red", fontSize: "12px" }}>response is empty!!</span> }
      </div>
    </div>
  );
}